<form id="CVR_GLN_LOOKUP"
      (submit)=" search(); $event.preventDefault();">
    <input type="search"
           name="id"
           oninput="this.parentElement.querySelector('button').disabled = this.value == null || this.value.length == 0 "
           [attr.placeholder]="'CVR_GLN_SEARCH.PLACEHOLDER.'+checkoutType | uppercase | translate">
    <button type="submit" disabled>
        <span>{{ 'CVR_GLN_SEARCH.BUTTON' | translate }}</span>
    </button>
</form>
